import { PAYMENT_GATEWAY } from "../../../core/constants/constants";
import { CheckoutPayload } from "../../../core/models/checkout-payload.model";
import { CreditCardModel } from "../../../core/models/credit-card.model";
import { GlobalConfig } from "../../../core/models/global-config.model";
import { PaymentGatewayModel } from "../../../core/models/payment-gateway.model";
import { UiStringModel } from "../../../core/models/ui-string.model";
import { UserBookingDetailsModel } from "../../../core/models/user-booking-details.model";
import * as $numberHelper from '../../../core/helpers/number.helper';

export class CheckoutStripeWallet {
  private stripePaymentRequest: stripe.paymentRequest.StripePaymentRequest;
  public stripe?: stripe.Stripe;
  public enabled: boolean = false;
    
  constructor(
    private readonly global: GlobalConfig,
    private readonly uiStrings: UiStringModel,
    private readonly shoppingCartTotalAmount: KnockoutObservable<number>,
    private readonly isPayWithApplePayVisible: KnockoutObservable<boolean>,
    private readonly isPayWithGPayVisible: KnockoutObservable<boolean>,
    private readonly bookingEmail: KnockoutObservable<string>,
    private readonly processPayment: (paymentType: string, partialPayload?: Partial<CheckoutPayload>, userDetails?: UserBookingDetailsModel) => void,
    private readonly processStripePayment: (cardToken: string, ev: stripe.paymentRequest.StripePaymentMethodPaymentResponse) => void
    
  ) { }

  public async initialise(walletGateway: PaymentGatewayModel) {
    if (this.shoppingCartTotalAmount() === 0) {
      return;
    }
    this.enabled = true;
    this.stripe = Stripe(walletGateway.publishableKey, { stripeAccount: walletGateway.accountStripeConnectId || undefined });

    this.loadStripePaymentRequest(this.shoppingCartTotalAmount());

    this.shoppingCartTotalAmount.subscribe((amount: number) => {
      this.stripePaymentRequest.update({ 
        currency: this.uiStrings.currencyCode.toLowerCase(),
        total: {
          label: 'Total amount',
          amount: $numberHelper.Round(amount * 100, 0)
        }
      });
    });
  }

  public showPaymentRequestSheet() {
    this.stripePaymentRequest.show();
  }

  private async loadStripePaymentRequest(amount: number) {       
    this.stripePaymentRequest = this.stripe.paymentRequest({
      country: this.uiStrings.isoRegionCode,
      currency: this.uiStrings.currencyCode.toLowerCase(),
      total: {
          label: 'Total amount',
          amount: $numberHelper.Round(amount * 100, 0)
      },
      requestPayerName: true,
      requestPayerEmail: true,
      requestPayerPhone: true,
    });
    
    const result = await this.stripePaymentRequest.canMakePayment();

    if (result.applePay) {
      this.isPayWithApplePayVisible(true);
    } 
    if (result.googlePay) {
      this.isPayWithGPayVisible(true);
    }
    if (!this.global.config.stripeSCAEnabled) {
      this.LegacyPaymentRequest();
    } else {
      this.processPaymentRequest();
    }
  }

    private processPaymentRequest() {
      let cardToken = '';
      this.stripePaymentRequest.on('token', ((ev: stripe.paymentRequest.StripeTokenPaymentResponse) => {
          cardToken = ev.token.id; // wtf???
      }));

      this.stripePaymentRequest.on('paymentmethod', (ev: stripe.paymentRequest.StripePaymentMethodPaymentResponse) => this.processStripePayment(cardToken, ev));
  }

  private LegacyPaymentRequest() {
    this.stripePaymentRequest.on('token', async (ev: stripe.paymentRequest.StripeTokenPaymentResponse) => {
      // NAME WORKAROUND
      var names = ev.payerName.split(' ');
      var firstName = names[0];
      var lastName = '';

      for (var i = 1; i < names.length; i++) {
          lastName += names[i] + ' ';
      }

      lastName = lastName.trim();

      var userDetails: UserBookingDetailsModel = {
        firstName: firstName.trim(),
        lastName: lastName.trim(),
        emailAddress: this.bookingEmail(),
        payerEmail: ev.payerEmail,
        address: ev.token.card?.address_line1,
        state: ev.token.card?.address_state,
        postCode: ev.token.card?.address_zip,
        phoneNumber: ev.payerPhone,
        countryCode: ev.token.card?.address_country,
        city: ev.token.card?.address_city,
        isQuickSale: false,
      };
      
      const payload: Partial<CheckoutPayload> = {
        paymentTypeName: ev.token.card!.brand.toLowerCase(),
        creditCard: {
          cardToken: ev.token.id,
          cardBrand: ev.token.card!.brand,
          cardCountry: ev.token.card!.country
        },
    };

      this.processPayment(ev.token.card!.brand.toLowerCase(), payload, userDetails);
    });
  }
}
